var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMaestro(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 20,
    viewBox: "0 0 30 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 20,
    rx: 4,
    fill: "#F8F8F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6243 14.7179H12.3748V5.28363H17.6243V14.7179Z",
    fill: "#6C6BBD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7113 9.99991C12.7113 8.08612 13.6073 6.38137 15.0027 5.28276C13.9823 4.4794 12.6945 3.99991 11.2949 3.99991C7.98152 3.99991 5.29565 6.68616 5.29565 9.99991C5.29565 13.3137 7.98152 15.9999 11.2949 15.9999C12.6945 15.9999 13.9823 15.5204 15.0027 14.7171C13.6073 13.6184 12.7113 11.9137 12.7113 9.99991Z",
    fill: "#EB001B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7045 9.99991C24.7045 13.3137 22.0186 15.9999 18.7053 15.9999C17.3057 15.9999 16.0179 15.5204 14.9971 14.7171C16.3928 13.6184 17.2889 11.9137 17.2889 9.99991C17.2889 8.08612 16.3928 6.38137 14.9971 5.28276C16.0179 4.4794 17.3057 3.99991 18.7053 3.99991C22.0186 3.99991 24.7045 6.68616 24.7045 9.99991Z",
    fill: "#0099DF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaestro);
export default __webpack_public_path__ + "static/media/maestro.38450468.svg";
export { ForwardRef as ReactComponent };